import { trackClientEvent } from '../../../../../trackClientEvent';
export const eventKey = 'retailer_team_management-insider_marketing_page_learn_more_redirect-click';
/**
 * Event to track user without checkout permissions being redirected to insider marketing page
 */
export function trackRetailerTeamManagementInsiderMarketingPageLearnMoreRedirectClick(customParameterToken) {
    return trackClientEvent({
        eventKey,
        realTimeTracking: false,
        parameters: { customParameterToken },
    });
}
